import {Brick, registerBrick, Transaction, ErrorFlow, BrickContext} from 'olympe';
import Assessment from "../../../../models/Assessment";
import Unit from "../../../../models/Unit";
import Observation from "../../../../models/Observation";
import Report from "../../../../models/Report";
import ReportLinkMissingObservations from "./ReportLinkMissingObservations";

export default class ReportLinkEvaluatedObservations extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} report
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    update($, [report], [forwardEvent, setErrorFlow]) {
        const transaction = new Transaction();

        // Remove existing observations from the report
        const selectedObservations = report.follow(Report.observationsRel).executeFromCache();
        for (const observation of selectedObservations.values()) {
            transaction.deleteRelation(Report.observationsRel, report, observation);
        }

        // Add evaluated observations to the report
        const evaluatedObservations = report.follow(Assessment.reportsRel.getInverse())
            .follow(Assessment.unitsRel).andReturn()
            .follow(Unit.observationsRel).andReturn()
            .follow(Observation.evalutationRel)
            .executeFromCache();

        const observationsToLink = new Set();
        for (const [unit, observation] of evaluatedObservations.values()) {
            // Ensure that we also add the parent observations to the report.
            ReportLinkMissingObservations.getParents(unit, observation).forEach((obs) => observationsToLink.add(obs.getTag()));
        }
        observationsToLink.forEach((observationTag) => transaction.createRelation(Report.observationsRel, report, observationTag));

        transaction.execute().then(forwardEvent).catch((e) => {
            setErrorFlow(ErrorFlow.create(`Failed to auto add observations to the report: ${e}`, 0));
        });
    }
}

registerBrick('018ae12ea4a8153f5257', ReportLinkEvaluatedObservations);
